import { Fragment, memo, ReactElement, useEffect, useState, useMemo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { PracticeEditCrumbs, PracticeNewCrumbs } from 'practice/constants/practice-crubs';
import { PmiButton } from 'shell/components/shared/button';
import { Grid, useEventCallback } from '@mui/material';
import Buttons from 'practice/components/edit/buttons';
import FormDetail from 'practice/components/edit/form';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { ModalViewerPDF } from 'shell/components/shared/pdf-modal';
import { HttpResponse, HttpResponseList } from 'shell/models/http-response';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import CancelDialog from 'practice/components/edit/cancel-dialog';
import { toast } from 'react-toastify';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { EccezioneVOList, PracticeData } from 'shell/models/practice';
import { PracticeSearchType, PracticeFilterSearchType } from '../storage-practice';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { NewPersonVM } from 'shell/components/shared/sipo-person-form/new-person';
import { blobToBase64 } from 'shell/utils/base64-to-blob';
import { TypeRegister } from 'practice/constants/type-register';
import ModalChangeParenthood, {
  FormModal,
} from 'practice/components/edit/form/shared/modal-change-parenthood';
import ModalConfirmMessi from 'practice/components/edit/form/shared/modal-confirm-messi';
import { DateTime } from 'luxon';
import { OtherFamiliarsServiceResponse } from 'shell/models/other-familiars';
import ModalMessage from 'practice/components/edit/form/shared/modal-message';
import ModalWarning from 'shell/components/shared/modal-warning';
import PmiTitle from 'shell/components/shared/title';
import { RegisterOfficeVM } from 'shell/view-models/register-office-practice-vm';
import { PracticeDraftStep, TypeInitiative } from 'practice/constants/practice-management-step';

interface PracticeEditProps {
  isNew?: boolean;
  ForPracticeTemporaryNew?: boolean;
}

const PracticeEditPageComponent = ({
  isNew,
  ForPracticeTemporaryNew,
}: PracticeEditProps): ReactElement => {
  const filterTable = useFilterTable<PracticeSearchType>();

  const params = useParams();

  const navigate = useNavigate();

  const ForPracticeTemporary = useMemo(() => {
    if (ForPracticeTemporaryNew) {
      // anagrafe temporanea NUOVA

      return ForPracticeTemporaryNew;
    }

    return params.tipoRegistro === TypeRegister.RegisterOfficeTemporary;
  }, [ForPracticeTemporaryNew, params]);

  // step corrente
  const [active, setActive] = useState<PracticeDraftStep>(PracticeDraftStep.RegisterOffice);

  // step massimo visitato, inizializzato da DB, si aggiorna se lo step corrente lo supera
  const [maxActiveStep, setMaxActiveStep] = useState<PracticeDraftStep>(
    PracticeDraftStep.RegisterOffice
  );

  const [pdfModal, setPdfModal] = useState({ data: '', open: false, name: '' });

  const [cancelModal, setCancelModal] = useState(false);

  // modale recap
  const [openModal, setOpenModal] = useState(false);

  // modale messaggio post recap
  const [openMessageModal, setOpenMessageModal] = useState(false);

  // modale parentela
  const [openModalParenthood, setOpenModalParenthood] = useState(false);

  // tipo iniziativa se R è ANPR E è ELIXFORM stessa gestione per entrambe
  const [tipoIniziativa, setTipoIniziativa] = useState<TypeInitiative>();

  // true se l'intestatario è AIRE
  const [intestatarioIsAnpr, setIntestatarioIsAnpr] = useState<boolean>(false);

  const [codOperatorePratica, setCodOperatorePratica] = useState<string>('');

  // step proveniente da DB usato come appoggio per i diversi controlli
  const [stepBozza, setStepBozza] = useState<number>(PracticeDraftStep.RegisterOffice);

  // dopo la conferma dei messi, vengono disabilitati tutti gli step che prevedono una modifica (non le stampe)
  const [disabledAll, setDisabledAll] = useState<boolean>(false);

  // true quando è stato richiesto l'accertamento messi quando si cambia step diventa false
  const [isAcceptMessi, setIsAcceptMessi] = useState<boolean>(false);

  // true se è presente il idWorkflowProcess
  const [isDisabledCancel, setIsDisabledCancel] = useState<boolean>(false);

  const [statoPratica, setStatoPratica] = useState<string>('');

  // Stato per gestire persona legittima o in ufficio
  const [fromPerson, setFromPerson] = useState<TypeInitiative | undefined>(
    TypeInitiative.idPersonaLegittima
  );

  // Stato per salvare richiedente e intestatario della pratica
  const [stepRegisterOfficeState, setStepRegisterOfficeState] = useState<RegisterOfficeVM>();

  // true quando, dallo step Recap, si clicca "Avanti": evidenzia il tasto Conferma senza cambiare pagina.
  // Viene resettato quando si clicca un altro tasto.
  const [highlightConfirm, setHighlightConfirm] = useState<boolean>(false);

  // reset di default: ogni cambio step (avanti/indietro/click diretto) rimuove l'evidenziazione.
  // Ci pensa poi l'if in onNext a rimetterlo a true quando serve (quel branch non cambia `active`).
  useEffect(() => {
    setHighlightConfirm(false);
  }, [active]);

  const isNotUnavailable = useMemo(() => {
    return (
      params.tipoRegistro !== TypeRegister.Unavailable &&
      params.tipoRegistro !== TypeRegister.UntraceableCensus
    );
  }, []);

  useEffect(() => {
    if (
      filterTable?.values?.searchType === PracticeFilterSearchType.SEARCH_BY_PRATICE ||
      filterTable?.values?.searchType === PracticeFilterSearchType.SEARCH_BY_PERSON
    ) {
      filterTable?.setValues({ ...filterTable?.values, isChildComponentVisited: true });
    }
  }, []);

  useEffect(() => {
    setMaxActiveStep((oldMaxActiveStep) => {
      if (
        stepBozza &&
        tipoIniziativa !== TypeInitiative.Anpr &&
        tipoIniziativa !== TypeInitiative.ElixForm &&
        !Boolean(oldMaxActiveStep) &&
        codOperatorePratica !== 'BATCH'
      ) {
        return stepBozza;
      }

      if (
        (tipoIniziativa === TypeInitiative.Anpr ||
          tipoIniziativa === TypeInitiative.ElixForm ||
          codOperatorePratica === 'BATCH') &&
        !Boolean(oldMaxActiveStep)
      ) {
        return PracticeDraftStep.ExceptionList;
      }

      return oldMaxActiveStep;
    });
  }, [stepBozza, tipoIniziativa, codOperatorePratica]);

  const resetId = useEventCallback(() => {
    // eliminare tutti gli ID contenuti nell'URL
    navigate(
      {
        pathname: generatePath(
          '/pratiche/ricerca/modifica/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:tipoPratica',
          {
            codiceEnte: params.codiceEnte || '',
            tipoRegistro: params.tipoRegistro || '',
            idAnnoPratica: params.idAnnoPratica?.toString() || '',
            progressivoPratica: params.progressivoPratica?.toString() || '',
            tipoPratica: params.tipoPratica || '',
          }
        ),
      },
      {
        replace: true,
      }
    );
  });

  const onNext = useEventCallback((step?: PracticeDraftStep) => {
    // eliminare tutti gli ID contenuti nell'URL
    resetId();

    if (step) {
      setActive(step);
      // if (step === PracticeDraftStep.AccertamentoMessi) {
      //   // se lo step attivo è accertamento messi, si rimane nello step e non si va avanti
      //   setMaxActiveStep(PracticeDraftStep.Recap);
      //   return;
      // }
      if (active === PracticeDraftStep.Recap) {
        // se lo step attivo è Recap, si rimane nello step e non si va avanti
        setMaxActiveStep(PracticeDraftStep.ExceptionList);
        return;
      }
      return;
    }

    if (
      (params.tipoRegistro === TypeRegister.Emigration || ForPracticeTemporary) &&
      active === PracticeDraftStep.Recap
    ) {
      // saltare accertamento messi se non mostrato

      if (maxActiveStep < PracticeDraftStep.AccertamentoMessi) {
        setMaxActiveStep(PracticeDraftStep.AccertamentoMessi);
      }

      return;
    }

    if (active === PracticeDraftStep.Recap) {
      // se lo step attivo è Recap, si rimane nello step e non si va avanti (a meno che non si è in una pratica di IMMGR o RESID)
      setMaxActiveStep(PracticeDraftStep.ExceptionList);

      if (
        params.tipoRegistro === TypeRegister.Immigration ||
        params.tipoRegistro === TypeRegister.Residence
      ) {
        // evidenzia il tasto Conferma senza cambiare pagina
        setHighlightConfirm(true);
      }

      return;
    }

    if (ForPracticeTemporary && active === PracticeDraftStep.RegisterOffice) {
      //saltare lo step della residenza
      setActive(PracticeDraftStep.Documents);

      if (maxActiveStep < PracticeDraftStep.Documents) {
        setMaxActiveStep(PracticeDraftStep.Documents);
      }

      return;
    }

    // Non è irreperibilità salto lo step 4
    if (
      (tipoIniziativa !== TypeInitiative.Anpr ||
        params.tipoRegistro === TypeRegister.Emigration ||
        (tipoIniziativa === TypeInitiative.Anpr &&
          params.tipoRegistro === TypeRegister.Immigration) ||
        isNotUnavailable) &&
      active === PracticeDraftStep.Documents
    ) {
      // saltare irreperibilità se non mostrato
      setActive(PracticeDraftStep.Recap);

      if (maxActiveStep < PracticeDraftStep.Recap) {
        setMaxActiveStep(PracticeDraftStep.Recap);
      }

      return;
    }

    setActive(active + 1);

    if (maxActiveStep < active + 1) {
      setMaxActiveStep(active + 1);
    }
  });

  const onBack = useEventCallback((step?: PracticeDraftStep) => {
    // eliminare tutti gli ID contenuti nell'URL
    resetId();

    if (step && typeof step === 'number') {
      setActive(step);
      return;
    }

    if (!active) {
      return;
    }

    if (ForPracticeTemporary && active === PracticeDraftStep.Documents) {
      //saltare lo step della residenza
      setActive(PracticeDraftStep.Family);
      return;
    }

    if (
      (tipoIniziativa !== TypeInitiative.Anpr || params.tipoRegistro === TypeRegister.Emigration) &&
      active === PracticeDraftStep.Recap
    ) {
      // saltare irreperibilità se non mostrato
      setActive(PracticeDraftStep.Documents);

      return;
    }

    if (
      (params.tipoRegistro === TypeRegister.Emigration || ForPracticeTemporary) &&
      active === PracticeDraftStep.AccertamentoMessi
    ) {
      // saltare accertamento messi se non mostrato
      setActive(
        tipoIniziativa !== TypeInitiative.Anpr || params.tipoRegistro === TypeRegister.Emigration
          ? PracticeDraftStep.Documents
          : PracticeDraftStep.Irricevibilita
      );

      return;
    }

    setActive(active - 1);
  });

  const handleStep = useEventCallback((id: number) => {
    // eliminare tutti gli ID contenuti nell'URL
    resetId();

    // set step attivo da bottoniere di sinistra
    setActive(id);
  });

  const dataNewPerson = useFilterTable<NewPersonVM>();

  useEffect(() => {
    if (dataNewPerson.values?.currentStep && dataNewPerson.values?.currentStep !== 0) {
      setActive(dataNewPerson.values?.currentStep);

      if (maxActiveStep <= dataNewPerson.values?.currentStep) {
        setMaxActiveStep(dataNewPerson.values?.currentStep);
      }

      if (stepBozza <= dataNewPerson.values?.currentStep) {
        setStepBozza(dataNewPerson.values?.currentStep);
      }
    }
  }, [dataNewPerson.values?.currentStep]);

  const printFolder = useHttpClient<Blob>(`${__PRACTICE_API_URL__}/pratiche/stampa/cartellina`, {
    options: { method: 'POST' },
  });

  const printLetter = useHttpClient<Blob>(
    `${__PRACTICE_API_URL__}/pratiche/stampa/lettera-comune-anagrafe-temporanea`,
    {
      options: { method: 'POST' },
    }
  );

  const printReceipt = useHttpClient<Blob>(`${__PRACTICE_API_URL__}/pratiche/stampa/ricevuta`, {
    options: { method: 'POST' },
  });

  const printReceiptForPracticeTemporary = useHttpClient<Blob>(
    `${__PRACTICE_API_URL__}/pratiche/stampa/ricevuta-anagrafe-temporanea`,
    {
      options: { method: 'POST' },
    }
  );

  const cancellOperation = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/annullo-operazione`, {
    options: { method: 'POST' },
  });

  const onPrintFolder = useEventCallback(() => {
    (
      printFolder({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Stampa Cartellina',
            open: true,
          });
        });
      }
    });
  });

  const onPrintLetter = useEventCallback(() => {
    (
      printLetter({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Stampa Lettera',
            open: true,
          });
        });
      }
    });
  });

  const onPrintReceipt = useEventCallback(() => {
    (
      printReceipt({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Stampa Ricevuta',
            open: true,
          });
        });
      }
    });
  });

  const onPrintReceiptForPracticeTemporary = useEventCallback(() => {
    (
      printReceiptForPracticeTemporary({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
        },
        responseType: 'blob',
      }) as ResponsePromise<Blob>
    ).then((response) => {
      const pdfCertificate = response?.data;
      if (pdfCertificate) {
        const blob = new Blob([pdfCertificate], { type: 'application/pdf' });
        blobToBase64(blob).then((base64) => {
          setPdfModal({
            data: base64.split(',')[1],
            name: 'Stampa Ricevuta',
            open: true,
          });
        });
      }
    });
  });

  const onCancel = useEventCallback(() => {
    setCancelModal(true);
  });

  const handleExit = useEventCallback(() => {
    navigate('/pratiche/ricerca');
  });

  const onConfirmCancelModal = useEventCallback(() => {
    (
      cancellOperation({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
        },
      }) as ResponsePromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');

      navigate('/pratiche/ricerca');
    });
  });

  const [eccezioni, loadEccezioni] = useHttpFetch<EccezioneVOList>(
    `${__PRACTICE_API_URL__}/pratiche/eccezioni/filtrate/${params.codiceEnte}-${params.idAnnoPratica}-${params.tipoRegistro}-${params.progressivoPratica}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
    }
  );

  const redirectUri = window.location.search.replace('?redirectUri=', '') || '';

  const handleRedirect = useEventCallback(() => {
    navigate(redirectUri);
  });

  // fetch to get other familiars for change relationship
  const [otherFamiliars, getOtherFamiliars] = useHttpFetch<
    HttpResponse<OtherFamiliarsServiceResponse>,
    FormModal
  >(
    `${__PRACTICE_API_URL__}/persona-parentela/list/${params.codiceEnte}-${params.idAnnoPratica}-${params.tipoRegistro}-${params.progressivoPratica}`,
    {
      onBootstrap: false,
      transformer: (response) => {
        return {
          otherFamiliars:
            response.data.payload?.altriFamiliari?.map((element) => {
              const isMinorenne = element.dataNascita
                ? DateTime.now().diff(DateTime.fromISO(element.dataNascita), 'years').years < 18
                : false;

              const parenthoodValue =
                !isMinorenne &&
                response.data.payload?.altriFamiliari?.length === 1 &&
                isNotUnavailable
                  ? '1'
                  : element.codAnprParentela?.toString() || '';
              return {
                fiscalCode: element.codFiscale || '',
                name: element.nome || '',
                surname: element.cognome || '',
                parenthoodValue,
                isMinorenne,
                element,
              };
            }) || [],
          newFamiliars:
            response.data.payload?.nuoviFamiliari?.map((element) => {
              const parenthoodValue =
                response.data.payload?.nuoviFamiliari?.length === 1 && isNotUnavailable
                  ? '1'
                  : element.codAnprParentela?.toString() || '';

              return {
                fiscalCode: element.codFiscale || '',
                name: element.nome || '',
                surname: element.cognome || '',
                parenthoodValue,
                elementFamilyPractice: element,
              };
            }) || [],
        };
      },
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
    }
  );

  const otherFamiliarsVM = (otherFamiliars.data as FormModal) || {};

  const onConfirmData = useHttpClient(`${__PRACTICE_API_URL__}/conferma/pratica`, {
    options: { method: 'POST', errorCatching: true },
  });

  const getCheckWarnings = useHttpClient<HttpResponse<{ warning: string[] }>>(
    `${__PRACTICE_API_URL__}/conferma/pratica/controlli`,
    {
      options: { method: 'POST' },
    }
  );

  const [warningModal, setWarningModal] = useState<{ open: boolean; message?: string }>({
    open: false,
  });

  const onConfirm = useEventCallback(() => {
    (
      getCheckWarnings({
        data: {
          codiceEnte: params.codiceEnte || undefined,
          tipoRegistro: params.tipoRegistro || undefined,
          idAnnoPratica: params.idAnnoPratica
            ? Number.parseInt(params.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
        },
      }) as ResponsePromise<HttpResponse<{ warning: string[] }>>
    ).then((resp) => {
      const respCasted = resp?.data.payload.warning || [];
      const hasWarnings = respCasted.length > 0;

      if (hasWarnings) {
        setWarningModal({
          open: true,
          message: respCasted.join('\n'),
        });
        return;
      }
      onConfirmSave();
    });
  });

  const onConfirmSave = useEventCallback(() => {
    (getOtherFamiliars() as ResponsePromise<HttpResponseList<PracticeData>, FormModal>).then(
      (response) => {
        const responseCasted = (response as FormModal) || {};

        const oldFamiliars = responseCasted?.otherFamiliars || [];

        const newOtherFamiliars = responseCasted?.newFamiliars || [];

        if (oldFamiliars.length > 0 || newOtherFamiliars.length > 0) {
          setOpenModalParenthood(true);
          return;
        }

        filterTable.setValues({
          fromNumber: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
          atNumber: params.progressivoPratica
            ? Number.parseInt(params.progressivoPratica, 10)
            : undefined,
          typeRegister: params.tipoRegistro,
          years: params.idAnnoPratica,
          isChildComponentVisited: true,
          searchType: PracticeFilterSearchType.SEARCH_BY_PRATICE,
        });

        setOpenModal(true);
      }
    );
  });

  const onCloseModalConfirmMessi = useEventCallback((isConfirm: boolean) => {
    if (!isConfirm) {
      setOpenModal(false);
      return;
    }

    const data = {
      codiceEnte: params.codiceEnte,
      tipoRegistro: params.tipoRegistro,
      idAnnoPratica: params.idAnnoPratica ? Number.parseInt(params.idAnnoPratica, 10) : undefined,
      progressivoPratica: params.progressivoPratica
        ? Number.parseInt(params.progressivoPratica, 10)
        : undefined,
    };

    (onConfirmData({ data }) as ResponsePromise<void>)
      .then(() => {
        setOpenModal(false);
        setDisabledAll(true);
        setOpenMessageModal(true);

        toast.success('Operazione eseguita con successo');
      })
      .catch(() => {
        setOpenModal(false);

        // se non riesce a confermare la pratica, vado sulla lista eccezioni
        setActive(PracticeDraftStep.ExceptionList);
        loadEccezioni();
      });
  });

  const onCancelModalParenthood = useEventCallback((isConfirm: boolean) => {
    if (isConfirm) {
      setOpenModal(true);
      filterTable.setValues({
        fromNumber: params.progressivoPratica
          ? Number.parseInt(params.progressivoPratica, 10)
          : undefined,
        atNumber: params.progressivoPratica
          ? Number.parseInt(params.progressivoPratica, 10)
          : undefined,
        typeRegister: params.tipoRegistro,
        years: params.idAnnoPratica,
        isChildComponentVisited: true,
        searchType: PracticeFilterSearchType.SEARCH_BY_PRATICE,
      });
    }

    setOpenModalParenthood(false);
  });

  useEffect(() => {
    setIsAcceptMessi((oldMessi) => {
      if (active !== PracticeDraftStep.AccertamentoMessi && oldMessi) {
        return false;
      }

      return oldMessi;
    });
  }, [isAcceptMessi, active]);

  useEffect(() => {
    if (active === PracticeDraftStep.ExceptionList) {
      loadEccezioni();
    }
  }, [active]);

  /**
   * Returns true if there are any blocked or ignored exceptions
   * @param eccezioni - the response from the API with the list of exceptions
   * @returns {boolean} true if there are any blocked or ignored exceptions
   */
  const withEccezioni = useMemo(() => {
    const { payload } = (eccezioni.data as EccezioneVOList)?.data || {};
    const { eccezioni: eccezioniBloccanti, eccezioniIgnorabili } = payload || {};

    return eccezioniBloccanti?.length > 0 || eccezioniIgnorabili?.length > 0;
  }, [eccezioni.data]);

  return (
    <Fragment>
      {warningModal.open ? (
        <ModalWarning
          message={warningModal.message || ''}
          open={warningModal.open}
          onClose={() => {
            setWarningModal({ open: false, message: '' });
            onConfirmSave();
          }}
          nameButton="Conferma"
          onAnnulment={() => {
            setWarningModal({ open: false, message: '' });
          }}
          withAnnulment
        />
      ) : undefined}
      <div className="pmi-d-block pmi-d-md-flex pmi-justify-content-between">
        <Breadcrumbs items={isNew ? PracticeNewCrumbs : PracticeEditCrumbs} />
        {redirectUri && !redirectUri.includes('idIntestatario') ? (
          <div className="pmi-my-2 pmi-w-30 pmi-w-lg-20">
            <PmiButton onClick={handleRedirect} fullWidth variant="outlined" color="cdmBrand">
              Torna indietro
            </PmiButton>
          </div>
        ) : null}
      </div>
      <PmiTitle title={isNew ? 'Nuova Pratica' : 'Modifica Pratica'} />
      <Grid container spacing={1}>
        <Grid item xs={12} md={3}>
          <Buttons
            isDisabledCancel={isDisabledCancel}
            onCancel={onCancel}
            handleExit={handleExit}
            handleStep={handleStep}
            activeStep={active}
            maxActiveStep={maxActiveStep}
            tipoIniziativa={tipoIniziativa}
            fromPerson={fromPerson}
            onPrintFolder={onPrintFolder}
            onPrintLetter={onPrintLetter}
            onPrintReceipt={
              ForPracticeTemporary ? onPrintReceiptForPracticeTemporary : onPrintReceipt
            }
            withEccezioni={withEccezioni}
            disabledAll={disabledAll}
            typeRegister={params.tipoRegistro}
            onConfirm={onConfirm}
            ForPracticeTemporary={ForPracticeTemporary}
            isAcceptMessi={isAcceptMessi}
            statoPratica={statoPratica}
            highlightConfirm={highlightConfirm}
          />
        </Grid>
        <Grid item xs={12} md={9}>
          <FormDetail
            ForPracticeTemporary={ForPracticeTemporary}
            step={active}
            identifierAnpr={params.codiceAnpr}
            onBack={onBack}
            onNext={onNext}
            stepRegisterOfficeState={stepRegisterOfficeState}
            setStepRegisterOfficeState={setStepRegisterOfficeState}
            setFromPerson={(el) => setFromPerson(el)}
            fromPerson={fromPerson}
            typeRegister={params.tipoRegistro}
            yearId={params.idAnnoPratica}
            progressive={params.progressivoPratica}
            idFamilyAnpr={params.idFamigliaAnpr}
            codeEnte={params.codiceEnte}
            typePractice={params.tipoPratica}
            intestatarioIsAnpr={intestatarioIsAnpr}
            setIntestatarioIsAnpr={setIntestatarioIsAnpr}
            setTipoIniziativa={setTipoIniziativa}
            setStepBozza={setStepBozza}
            setIsDisabledCancel={setIsDisabledCancel}
            stepBozza={stepBozza}
            iniziativa={tipoIniziativa}
            setCodOperatorePratica={setCodOperatorePratica}
            codOperatorePratica={codOperatorePratica}
            maxActiveStep={maxActiveStep}
            eccezioni={eccezioni.data as EccezioneVOList}
            setDisabledAll={setDisabledAll}
            disabledAll={disabledAll}
            setIsAcceptMessi={setIsAcceptMessi}
            setStatoPratica={setStatoPratica}
          />
        </Grid>
      </Grid>
      {pdfModal.open ? (
        <ModalViewerPDF
          open={pdfModal.open}
          data={pdfModal.data}
          name={pdfModal.name}
          title="Stampa"
          onClose={() => {
            setPdfModal({ data: '', open: false, name: '' });
          }}
        />
      ) : undefined}
      {cancelModal ? (
        <CancelDialog
          isOpen={cancelModal}
          onAbort={() => setCancelModal(false)}
          onClose={() => setCancelModal(false)}
          onConfirm={onConfirmCancelModal}
        />
      ) : undefined}
      {openModal ? (
        <ModalConfirmMessi
          typeRegister={params.tipoRegistro}
          yearId={params.idAnnoPratica}
          progressive={params.progressivoPratica}
          codeEnte={params.codiceEnte}
          open={openModal}
          onClose={onCloseModalConfirmMessi}
        />
      ) : undefined}
      {openModalParenthood ? (
        <ModalChangeParenthood
          open={openModalParenthood}
          onClose={onCancelModalParenthood}
          otherFamiliars={otherFamiliarsVM?.otherFamiliars}
          newFamiliars={otherFamiliarsVM?.newFamiliars}
          typeRegister={params.tipoRegistro}
          yearId={params.idAnnoPratica}
          progressive={params.progressivoPratica}
          codeEnte={params.codiceEnte}
          fromPerson={fromPerson}
        />
      ) : undefined}
      {openMessageModal ? (
        <ModalMessage onClose={() => navigate('/pratiche/ricerca')} open={openMessageModal} />
      ) : undefined}
    </Fragment>
  );
};

PracticeEditPageComponent.displayName = 'Practice Edit Page component';

const PracticeEditPage = memo(PracticeEditPageComponent);

export default PracticeEditPage;
